export const LANDING = {
  ctaStart: 'landing-cta-start',
  ctaLearn: 'landing-cta-learn',
  navLogo: 'landing-nav-logo',
  navLaunch: 'landing-nav-launch',
  featureCard: 'landing-feature-card',
  ctaFooter: 'landing-cta-footer',
};

export const WORKSPACE = {
  root: 'workspace-root',
  tabDrafting: 'workspace-tab-drafting',
  tabResearch: 'workspace-tab-research',
  tabPredicate: 'workspace-tab-predicate',
  tabMaude: 'workspace-tab-maude',
  tabLibrary: 'workspace-tab-library',
};

export const DRAFT = {
  docTypeCard: 'draft-doctype-card',
  deviceNameInput: 'draft-device-name',
  intendedUseInput: 'draft-intended-use',
  deviceClassSelect: 'draft-device-class',
  predicateInput: 'draft-predicate',
  featuresInput: 'draft-features',
  populationInput: 'draft-population',
  notesInput: 'draft-notes',
  generateBtn: 'draft-generate-btn',
  exportPdfBtn: 'draft-export-pdf',
  exportDocxBtn: 'draft-export-docx',
  backBtn: 'draft-back-btn',
  output: 'draft-output',
};

export const CHAT = {
  input: 'chat-input',
  sendBtn: 'chat-send-btn',
  newBtn: 'chat-new-btn',
  messagesList: 'chat-messages',
  suggestionCard: 'chat-suggestion',
};

export const PREDICATE = {
  searchInput: 'predicate-search-input',
  searchBtn: 'predicate-search-btn',
  resultRow: 'predicate-result-row',
  compareBtn: 'predicate-compare-btn',
  subjectInput: 'predicate-subject-input',
  subjectDescInput: 'predicate-subject-desc',
  runCompareBtn: 'predicate-run-compare',
};

export const MAUDE = {
  searchInput: 'maude-search-input',
  searchBtn: 'maude-search-btn',
  summarizeBtn: 'maude-summarize-btn',
  resultRow: 'maude-result-row',
};

export const LIBRARY = {
  item: 'library-item',
  openBtn: 'library-open-btn',
  deleteBtn: 'library-delete-btn',
};
